import { render, staticRenderFns } from "./administrationNotice.vue?vue&type=template&id=1d5b6d72&scoped=true"
import script from "./administrationNotice.vue?vue&type=script&lang=js"
export * from "./administrationNotice.vue?vue&type=script&lang=js"
import style0 from "./administrationNotice.vue?vue&type=style&index=0&id=1d5b6d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b6d72",
  null
  
)

export default component.exports